export const onboarding = {
  activate: {
    page: {
      heading: "Your personalized <nobr>plan is ready</nobr>",
      subheading: "Activate your FREE membership now and see how <nobr>Conceive can support you</nobr>",
      help: "Having trouble finding your code?",
    },
    card: {
      heading: "ACTIVATION",
      description:
        "Just share your unique {{partnerName}} code and you’re all set! You can find your code in your welcome email from {{partnerName}}.",
      placeholder: "{{partnerName}} code",
      cta: "Activate membership",
    },
    modal: {
      heading: "Having trouble finding your code?",
      description1:
        "Your code is in your welcome email from {{partnerName}}. If you’re having trouble accessing it, message your {{partnerName}} contact.",
      description2: "Reach out to <EmailLink>{{partnerEmail}}</EmailLink> if you need any further assistance.",
      cta: "Got it",
    },
  },
  birthdayPage: {
    description:
      "No triggers intended. Age may not play as much of a factor in your fertility or pregnancy as once thought, but it is important for us to know to tailor your care plan.",
    placeholder: "mm / dd / yyyy",
    question: "When is your birthday?",
  },
  clinicReferPage: {
    comment:
      "If your clinic referred you, you may have special access to Conceive as part of your care. Answering this helps us make sure you’re connected to the right resources.",
    question: "Were you referred to Conceive by your clinic?",
    additionalQuestion: {
      question: "Please select your clinic",
      placeholder: "Select your clinic",
    },
  },
  clinicSatisfactionPage: {
    question: "How satisfied are you with your current clinic?",
    scale: {
      lowest: "Looking for a new clinic",
      highest: "I love my clinic",
    },
  },
  coveragePage: {
    additionalQuestion: {
      placeholder: "Share here ...",
      question: "Feel free to tell us a little more about it...",
    },
    alt: "Profile picture of Lauren Berson",
    comment:
      "75% of Americans have zero fertility coverage. We think that’s nuts. We’re working on it. If you don’t have coverage and you need it, we’d like to see if we can help with costs.",
    question: "Out of curiousity, do you have any fertility coverage?",
  },
  ctas: {
    finish: "Submit",
    next: "Next",
  },
  partnerLoading: {
    loading: "Loading",
    loadError: "We couldn’t load this page. Please try again.",
    tryAgain: "Try again",
  },
  currentClinicPage: {
    comment: "This helps us tailor your experience and make our support more relevant to your care.",
    question: "Are you currently working with a fertility clinic?",
    clinicQuestion: {
      question: "What fertility clinic are you working with?",
      instruction: "Start typing the clinic name. If you don’t see it, choose “Other.”",
      placeholder: "Enter your clinic name",
    },
    physicianQuestion: {
      question: "Who is your doctor? If you’re not sure or haven’t been assigned one yet, you can skip this.",
      placeholder: "Doctor’s name",
    },
  },
  dueDatePage: {
    description:
      "Knowing approximately when you’re due helps us tailor your experience. Of course, it may change, but sharing if you know it is super helpful.",
    placeholder: "mm / dd / yyyy",
    postpartumDescription: "Knowing when you gave birth helps us tailor your experience.",
    postpartumQuestion: "When did you have your child?",
    question: "What’s your due date (if you know it)?",
  },
  emailPage: {
    acceptedTerms:
      "I accept Conceive’s <TermsLink>Terms of Service</TermsLink> and <PrivacyPolicyLink>Privacy Policy</PrivacyPolicyLink>. I understand that Conceive connects me with providers and fertility/prenatal experts to support and educate me throughout my journey. Conceive does not offer medical advice and is not licensed to provide such services.",
    acceptedAdditionalTerms:
      "I understand and acknowledge that Conceive may collect and use my health information to provide the services, in accordance with Conceive’s <PrivacyPolicyLink>Privacy Policy</PrivacyPolicyLink> and <CHPNotice>Consumer Health Privacy Notice</CHPNotice>.",
    description: "We'll use this to save your answers and create your customized experience.",
    placeholders: {
      email: "Email address",
    },
    question: "Welcome {{name}}!<br/> What's your email address?",
  },
  employerPage: {
    description: "We ask this to protect your confidentiality",
    question: "Are you currently employed? If so, do you mind sharing where?",
    placeholder: "Share here",
  },
  healthConditionsPage: {
    additionalQuestion: {
      placeholder: "Share here ...",
      question: "Can you share which condition(s)?",
    },
    question:
      "Do you have any chronic or inherited health conditions that have impacted or are likely to impact your fertility or pregnancy?",
  },
  howAnxiousPage: {
    question: "In the past two weeks, how has your anxiety level been?",
    scale: {
      lowest: "Not anxious",
      highest: "Very anxious",
    },
  },
  howDidYouHearPage: {
    question: "How did you hear about us?",
  },
  howGratefulPage: {
    question: "In the past two weeks, how grateful have you been feeling?",
    scale: {
      lowest: "Not grateful",
      highest: "Very grateful",
    },
  },
  howLongPage: {
    comment:
      "Lauren here, Conceive's founder. I've been through my own challenging fertility journey (twice) and pregnant twice (once a loss; once with my miracle daughter). I'll be sharing some of my real-life experiences as you start this journey in hopes it will help you answer some of the questions.",
    question: "How long have you been trying to conceive?",
  },
  howOptimisticPage: {
    question: "In the past two weeks, how optimistic have you felt?",
    scale: {
      lowest: "Not optimistic",
      highest: "Very optimistic",
    },
  },
  howSupportedPage: {
    question: "How supported do you currently feel on your journey?",
    scale: {
      lowest: "Unsupported",
      highest: "Very supported",
    },
  },
  inputs: {
    checkbox: "Choose as many as you like",
  },
  journeyLooksLikePage: {
    additionalQuestion: {
      placeholder: "Share here ...",
      question: "Can you share more about your “Other” experiences?",
    },
    comment:
      "Lauren again, Conceive's founder. No two journeys are exactly alike, and some are more technical than others. The more we know about yours, the better we’re able to tailor your experience. I went from trying at home to IUI, IVF, and back again for what feels like 1 trillion times before I became pregnant with my daughter. Anyone else?",
    description: "Choose the closest fit. You can always update this and add more context later.",
    question: "Where are you in your fertility journey?",
  },
  nextMilestonePage: {
    question: "Where are you right now in your treatment at your current clinic?",
  },
  laurenQuote: {
    heading: "Lauren’s Note",
  },
  medicalDiagnosisPage: {
    additionalQuestion: {
      placeholder: "Share here ...",
      question: "Would you share which diagnosis or condition(s)?",
    },
    comment:
      "Lauren again. I was diagnosed with unexplained infertility at the beginning of my journey without my partner ever being checked! Wild, right?",
    description:
      "This can include PCOS, endometriosis, amenorrhea, adenomyosis, male factor, luteal phase defect, unexplained infertility, diminished ovarian reserve... the list goes on...",
    question:
      "Have you been diagnosed with a medical cause of infertility or a condition that could impact pregnancy at any point in your life?",
  },
  mostChallenging: {
    placeholder: "Share with us here...",
    question: "In your words, what has been the most challenging part of your journey?",
  },
  namePage: {
    placeholders: {
      firstName: "First name",
      lastName: "Last name",
    },
    question: "First off, what's your name?",
  },
  moreTreatmentDetailsPage: {
    options: {
      donorSperm: "Donor sperm",
      sameSexCouple: "Same sex couple",
      havePartner: "I have a partner in this journey",
      independent: "I'm doing this independently",
    },
    question: "Do any of these apply to you? (Select all that apply).",
  },
  phonePage: {
    description: {
      default:
        "Your front door to Conceive is texting with us. We'll use this to connect you with our on-demand nurse and coach team.",
      partner:
        "Last but not least, your front door to Conceive is texting with us. We'll use this to connect you with our on-demand nurse and coach team.",
    },
    duplicate: {
      heading: "Looks like there is already an account tied to this number",
      signInCta: "Sign in to your account",
      contactCta: "Contact us for help",
    },
    international: "I'm using an international number",
    placeholder: "(201) 555 - 0123",
    question: "What is your mobile number?",
  },
  pregnancyBackgroundPage: {
    additionalQuestion: {
      placeholder: "Share here ...",
      question: "Can you share more about your “Other” experiences?",
    },
    question: "Have you been pregnant before?",
  },
  providersSeen: {
    additionalQuestion: {
      placeholder: "Share here ...",
      question: "What “Other” providers you have you seen?",
    },
    description: "We ask this to better tailor your recommendations.",
    question: "What providers have you seen so far?",
  },
  providerSelect: {
    description: "Who is your provider?",
  },
  someLogisticsPage: {
    alt: "Hands on yellow background",
    continueCta: "Let's dive in!",
    description: "Almost done!<br/>We have just a few more practical questions",
    heading: "Some logistics",
    qualifier: "Next up:",
  },
  welcomeNamePage: {
    heading: "Your <Highlight>fertility support</Highlight><br/><nobr>system starts here</nobr>",
    partner: {
      heading: "Fertility treatment doesn’t stop at 5pm.<br/>Neither do we.",
      boxContent:
        "Your care at {{partnerName}} includes <Highlight>24/7 fertility support</Highlight><br/>—at no cost to you",
      disclaimer: "No credit card. No hidden fees.",
      estimatedTime: "1 minute",
    },
    placeholders: {
      firstName: "First name",
      lastName: "Last name",
    },
    question: "First off, what's your name?",
    step1: {
      content: "Tell us where you’ve been <nobr>and what you need</nobr>",
      estimatedTime: "1 minute",
    },
    step2: {
      content: "Our experts will create your personalized experience",
    },
  },
  welcomePage: {
    heading: {
      desktop: "Your <Highlight>fertility and pregnancy support</Highlight><br/><nobr>system starts here</nobr>",
      mobile:
        "Your <Highlight>fertility and</Highlight><br/><Highlight>pregnancy support</Highlight><br/><nobr>system starts here</nobr>",
    },
    nextCta: "Let's do this!",
    step1: {
      content: "Tell us where you’ve been <nobr>and what you need</nobr>",
      estimatedTime: "5 minutes",
    },
    step2: {
      content: "Our team of nurses and peer coaches will create your personalized experience",
    },
    step3: {
      content: "Try it all out with our <nobr><strong>FREE two week-trial</strong></nobr>",
    },
  },
  yourFertilityJourneyPage: {
    alt: "Hands overlaid with rainbow background",
    description: "We’ll be asking a few questions to get a sense of your journey so far",
    nextCta: "Continue",
    qualifier: "Next up:",
    heading: "Your Fertility Journey",
  },
  zipPage: {
    placeholder: "12345",
    question: "Let’s personalize your recommendations: What is your zip code?",
  },
};
